import { Tenant } from 'generated/api';
import { createResettableSlice } from 'careand-redux/utils/makeResettable';
import { unwrap, unwrapApi } from 'careand-redux/utils/unwrap';
import { api } from '../api/ApiThunks';

export interface TenantsState {
  byId: Record<string, Tenant | undefined>;
}

const initialState: TenantsState = {
  byId: {},
};

const slice = createResettableSlice({
  name: 'Tenants',
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder.addCase(
      api.Tenants.listTenants.fulfilled,
      unwrapApi((state, tenants) => {
        state.byId = {};
        tenants.forEach((tenant) => {
          state.byId[tenant.id!] = tenant;
        });
      }),
    ),
});

function insert(state: TenantsState, payload: Tenant | Tenant[]) {
  if (Array.isArray(payload)) {
    payload.forEach((it) => {
      state.byId[it.id] = it;
    });
  } else {
    state.byId[payload.id] = payload;
  }
}

export const tenantActions = slice.actions;
export default slice.reducer;
